import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import type { Image, LinkType } from 'types'

import { generateCommentsFullPathUrl } from 'ui-component-library/utils/helpers'
import { getCommentLabelTextString } from 'store/strings/selectors'
import useCommentsCount from 'hooks/useCommentsCount'
import ArticleSummary from 'ui-component-library/components/ArticleSummary'

type Props = {
  topicId: string
  link: LinkType
  fullPath?: string
  image: Image
  articleSource: 'internal' | 'external'
  headlineText: string
  articleDate: string
}

function FeaturedDailyArticleContainer({
  topicId,
  articleSource,
  link,
  fullPath,
  headlineText,
  ...rest
}: Props) {
  const commentsCount = useCommentsCount(topicId)
  const commentLabelText = useSelector(getCommentLabelTextString)
  const commentsUrl = useMemo(() => {
    let path = ''

    if (articleSource === 'external' && fullPath) {
      path = fullPath
    } else {
      path = link.url
    }

    return generateCommentsFullPathUrl({ fullPath: path, topicId })
  }, [articleSource, fullPath, link, topicId])

  return (
    <ArticleSummary
      topicId={topicId}
      allowModal
      articleSource={articleSource}
      link={link}
      headlineText={headlineText}
      commentsUrl={commentsUrl}
      commentLabelText={commentLabelText}
      commentsCount={commentsCount}
      {...rest}
    />
  )
}

export default FeaturedDailyArticleContainer
